import { IMasterAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export function getMasterAgentId(masterAgent?: IMasterAgentSchema): number | undefined {
  return (masterAgent && masterAgent.cianUserId) || undefined;
}
